import React, { useState } from "react";
import PropTypes from 'prop-types';
import {
    IconButton,
    InputAdornment,
    TextField,
} from "@material-ui/core";

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const SensitiveField = props => {
    const [showSensitiveValue, setShowSensitiveValue] = useState(false)

    const handleClick = () => {
        setShowSensitiveValue(!showSensitiveValue);
    };

    const handleMouseDown = event => {
        event.preventDefault();
    };

    return (
        <TextField
            readOnly
            fullWidth
            {...props}
            value={showSensitiveValue ? props.value : '*********'}
            type={showSensitiveValue ? 'text' : 'password'}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton
                            aria-label={`toggle ${props.label} visibility`}
                            onClick={handleClick}
                            onMouseDown={handleMouseDown}
                            edge="start"
                        >
                            {showSensitiveValue ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                )
            }}
        />
    );
};

SensitiveField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
};

SensitiveField.defaultProps = {
    value: null,
};

export default SensitiveField;
